"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SpeedCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SpeedCircleLinear = function SpeedCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M34 27a1 1 0 10-2 0v5a1 1 0 001 1h5a1 1 0 100-2h-4v-4z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint0_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 42a1 1 0 100-2 1 1 0 000 2z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint1_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint2_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 24a1 1 0 100-2 1 1 0 000 2z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint3_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 32a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint4_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 32c0-6.25 4.41-11.47 10.288-12.717a3 3 0 115.425 0C41.59 20.531 46 25.75 46 32c0 7.18-5.82 13-13 13s-13-5.82-13-13zm13-11c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11zm1-3a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint5_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 37a1 1 0 100 2h6a1 1 0 100-2h-6z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint6_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 33a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint7_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21a1 1 0 100 2h6a1 1 0 100-2h-6z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint8_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm0-2c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28z",
    fill: "url(#SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint9_linear_17373_95598)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint0_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint1_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint2_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint3_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint4_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint5_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint6_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint7_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint8_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SpeedCircleLinear_svg__SpeedCircleLinear_svg__paint9_linear_17373_95598",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.SpeedCircleLinear = SpeedCircleLinear;
var _default = SpeedCircleLinear;
exports.default = _default;